import React from "react";
// MUI
import { Dialog, Button, AppBar, Toolbar, Slide, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function ContentPreview({ open, contenttitle, content, onClose }) {
  const handleOnClose = () => {
    onClose();
  };

  return (
    <>
      <Dialog fullScreen open={open} onClose={handleOnClose} TransitionComponent={Transition}>
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              {contenttitle}
            </Typography>
            <IconButton edge="start" color="inherit" onClick={handleOnClose} aria-label="close">
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%" }}>
          <div style={{ padding: "0 10px", width: "230px", height: "460px", border: "10px solid gray", borderRadius: "15px", wordBreak: "break-all", overflowY: "auto" }}>
            <div dangerouslySetInnerHTML={{ __html: content }}></div>
          </div>
        </div>
      </Dialog>
    </>
  );
}

export default ContentPreview;
